import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { showRoyalPopup } from '../../actions/common/index';
import { ImageWebP } from '../../assets/util';
import { withRouter } from 'react-router-dom';

class RoyalPopup extends Component {

    constructor(props) {
        super(props);
        this.onCloseClick = this.onCloseClick.bind(this);
        this.onClick = this.onClick.bind(this);
    }

    onCloseClick() {
        const { showRoyalPopup } = this.props
        showRoyalPopup(false);
        localStorage.setItem('RoyalPopupForceCloseDate', moment().format("YYYY-MM-DD HH:mm:ss"))
    }

    onClick() {
        const { showRoyalPopup, royalPopup, history, location } = this.props
        showRoyalPopup(false);
        localStorage.setItem('RoyalPopupForceCloseDate', moment().format("YYYY-MM-DD HH:mm:ss"))
        if (royalPopup.link && royalPopup.link !== location.pathname) {
            history.push(royalPopup.link);
        }
    }

    render() {
        const { royalPopup } = this.props
        if (!royalPopup || !royalPopup.img) {
            return null
        }
        return (
            <div className="bt-popup-backdrop">
                <div className="bt-popup" style={{ backgroundColor: "transparent" }}>
                    <label className="btn-close" style={{ zIndex: 1 }} onClick={this.onCloseClick}><FontAwesomeIcon icon={["fal", "times"]} style={{ height: "25px", width: "25px", color: "#fff", backgroundColor: royalPopup.close_button_color || "#ccc" }} /></label>
                    <div className="">
                        <ImageWebP onClick={this.onClick} src={royalPopup.img} alt={royalPopup.name} style={{ width: "550px", maxWidth: "90vw" }} />
                        {/* <img src={`https://cdn.thebeautrium.com/image-royal/20-07-28-kingbd.jpg`} alt="ทรงพระเจริญ" style={{width: "550px", maxWidth: "90vw"}} /> */}
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        royalPopup: state.common.royal_popup,
    }
}
export default withRouter(connect(mapStateToProps, { showRoyalPopup })(RoyalPopup))